// TopBar.jsx — barra superior fija con navegación y CTA de donar.

import React from 'react'
import { trackCta } from '../../lib/analytics.js'
import { LogoCbqImg } from '../CampaignMediaImg.jsx'

function TopBar({ onDonate }) {
  return (
    <header className="topbar">
      <div className="wrap topbar-inner">
        <a className="brand" href="#top">
          <span className="brand-mark">
            <LogoCbqImg />
          </span>
          <span className="brand-text">
            Bomberos Quilpué
            <small>Campaña #MecanicaParaQuilpue</small>
          </span>
        </a>
        <nav className="topnav">
          <a href="#por-que">Por qué</a>
          <a href="#como">Cómo donar</a>
          <a href="#en-vivo">Aportes</a>
          <a href="#compartir">Compartir</a>
          <a href="#faq">Preguntas</a>
        </nav>
        <button
          className="topbar-cta"
          onClick={() => {
            trackCta("topbar_donar")
            onDonate()
          }}
        >
          Donar ahora
        </button>
      </div>
    </header>
  );
}

export { TopBar };
